<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><strong><em>The Marquis de Sade</em></strong></p>
<p class="center"><em>The 120 Days of Sodom and other writings</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?fa8073d4